module.exports = __webpack_public_path__ + "media/images/client-27-6b04e57c279f96dc191f5c2471e834a4.png";